import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SdHeadingComponent } from '@sdvor/seo/ui';
import { SdvorAdditionalOptionsModule } from '../../components/additional-options';
import { SdvorCheckoutContactsModule } from '../../components/checkout-contacts';
import { SdvorCheckoutOrderSummaryModule } from '../../components/checkout-order-summary';
import { SdvorCheckoutPaymentModule } from '../../components/checkout-payment/checkout-payment.module';
import { SdvorCheckoutSwitchProfileModule } from '../../components/checkout-switch-profile';
import { SdvorReceiptAddressModule } from '../../components/receipt/receipt-address/receipt-address.module';
import { SdvorReceiptTypeTabsModule } from '../../components/receipt/receipt-type-tabs/receipt-type-tabs.module';
import { SdvorTimeSlotModule } from '../../components/time-slot';

@Component({
  selector: 'sd-checkout-page',
  imports: [
    SdHeadingComponent,
    SdvorCheckoutSwitchProfileModule,
    SdvorReceiptTypeTabsModule,
    SdvorReceiptAddressModule,
    SdvorTimeSlotModule,
    SdvorAdditionalOptionsModule,
    SdvorCheckoutPaymentModule,
    SdvorCheckoutContactsModule,
    SdvorCheckoutOrderSummaryModule,
  ],
  templateUrl: './checkout-page.component.html',
  styleUrl: './checkout-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutPageComponent {}
